/*jshint -W008 */

jQuery(document).ready(function($) {

	function animTwoUpHeader($this) {

		const animTwoUpHeader = gsap.timeline({ id: 'tl--two-up--textuals' });

		// create custom bezier with Greensock
		CustomEase.create('twoUpEase', "0,0,0,1");
		CustomEase.create('twoUpHeaderEase', "0.075,  0.820,  0.165,  1.000");
		CustomEase.create('twoUpEaseInOut', "0.215,  0.610,  0.355,  1.000");

/*$ease-out-quad:     cubic-bezier( 0.250,  0.460,  0.450,  0.940 );
$ease-out-cubic:    cubic-bezier( 0.215,  0.610,  0.355,  1.000 );
$ease-out-quart:    cubic-bezier( 0.165,  0.840,  0.440,  1.000 );
$ease-out-quint:    cubic-bezier( 0.230,  1.000,  0.320,  1.000 );
$ease-out-sine:     cubic-bezier( 0.390,  0.575,  0.565,  1.000 );
$ease-out-expo:     cubic-bezier( 0.190,  1.000,  0.220,  1.000 );
$ease-out-circ:     cubic-bezier( 0.075,  0.820,  0.165,  1.000 );
$ease-out-back:     cubic-bezier( 0.175,  0.885,  0.320,  1.275 );

$ease-in-out-quad:  cubic-bezier( 0.455,  0.030,  0.515,  0.955 );
$ease-in-out-cubic: cubic-bezier( 0.645,  0.045,  0.355,  1.000 );
$ease-in-out-quart: cubic-bezier( 0.770,  0.000,  0.175,  1.000 );
$ease-in-out-quint: cubic-bezier( 0.860,  0.000,  0.070,  1.000 );
$ease-in-out-sine:  cubic-bezier( 0.445,  0.050,  0.550,  0.950 );
$ease-in-out-expo:  cubic-bezier( 1.000,  0.000,  0.000,  1.000 );
$ease-in-out-circ:  cubic-bezier( 0.785,  0.135,  0.150,  0.860 );
$ease-in-out-back:  cubic-bezier( 0.680, -0.550,  0.265,  1.550 );*/

		const $title 			= $this.find('.module__title'),
			  titleLinesArr 	= gsap.utils.toArray( $title.find('.line__inner-wrap') ),
			  $desc 			= $this.find('.module__desc'),
			  descLinesArr 		= gsap.utils.toArray( $desc.find('.line__inner-wrap') ),
			  $itemImg 			= $this.find('.img-wrap img'),
			  itemImgArr 		= gsap.utils.toArray( $itemImg );

		gsap.set($itemImg, {x: '-50%', y: '-50%'});

		animTwoUpHeader	
			.to(
				itemImgArr,
				{
					scale: 1,
					opacity: 1,
					x: '-50%',
					y: '-50%',
					ease: 'twoUpEaseInOut',
					duration: 1.666
				},
				0
			)
			.to(
				titleLinesArr, 
				{
				  	y: '0%',
				  	ease: 'twoUpHeaderEase',
				  	duration: 1,
				  	stagger: {
				  		each: .1,
					}
				},
				.34
			)
			.to(
				descLinesArr, 
				{
				  	y: '0%',
				  	autoAlpha: 1,
				  	ease: 'twoUpHeaderEase',
				  	duration: 1,
				  	stagger: {
				  		each: .1,
					}
				},
				.44
			);

		animTwoUpHeader.eventCallback(
			'onComplete',
			function() {

				const key 	= 'mac-anim--two-up',
					  value = '1';

				// we can omit the ttl parameter since it defaults to 1 day 
				MacFunctions.lsSetWithExpiry(key, value);

			}
		);				

		return animTwoUpHeader;			

	} 

	function animTwoUpItems($this) {

		const animTwoUpItems = gsap.timeline({ id: 'tl--two-up--items' });

		// create custom bezier with Greensock
		CustomEase.create('twoUpEase', "0,0,0,1");
		CustomEase.create('twoUpHeaderEase', "0.075,  0.820,  0.165,  1.000");

		const $items 	= $this.find('[class*="item--"]'),
			  itemsArr	= gsap.utils.toArray($items);

		itemsArr.forEach(item => {
		
			const animItem 	= gsap.timeline({ id: 'tl--two-up--item' }),
				  $item 	= $(item);	

			const $itemTitle 		= $item.find('.item__title'),
				  itemTitleLinesArr = gsap.utils.toArray( $itemTitle.find('.line__inner-wrap') ),
				  $itemDesc 		= $item.find('.item__desc'),
				  itemDescLinesArr 	= gsap.utils.toArray( $itemDesc.find('.line__inner-wrap') ),
				  $itemCta 			= $this.find('.item__cta');

			animItem	
				.to(
					itemTitleLinesArr, 
					{
					  	y: '0%',
					  	ease: 'twoUpHeaderEase',
					  	duration: 1,
					  	stagger: {
					  		each: .1,
						}
					},
					.34
				)
				.to(
					itemDescLinesArr, 
					{
					  	y: '0%',
					  	opacity: 1,
					  	ease: 'twoUpHeaderEase',
					  	duration: 1,
					  	stagger: {
					  		each: .1,
						}
					},
					.44
				)
				.to(
					$itemCta, 
					{
					  	y: '0%',
					  	opacity: 1,
					  	ease: 'twoUpHeaderEase',
					  	duration: 1,
					},
					.34
				);

			animTwoUpItems
				.add(animItem, 0);

		});

		return animTwoUpItems;			

	} 	

	function twoUpInit($this) {

		const twoUpMasterTl = gsap.timeline();
		
		twoUpMasterTl
			.add(animTwoUpHeader($this))
			.add(animTwoUpItems($this), '-=1.333');

		twoUpMasterTl.eventCallback(
			'onStart', 
			function() {
				$this.addClass('anim--two-up--start');
			}
		);	

		twoUpMasterTl.eventCallback(
			'onComplete', 
			function() {

				$this.addClass('anim--two-up--complete');
				
			}
		);	

	}

	if (
			!$('html').is('.anim--two-up--complete') &&	 
			$('.mac-module--2-up[data-design=featured]').length 
		) {

		$('.mac-module--2-up[data-design=featured]').each( function(i) {

			const $this = $(this);

			/**
			 * Split and/or wrap the stuff
			 * ====================================================================================
			 * ====================================================================================
			 * ====================================================================================
			 */

			const splitTwoUpTitle 	= new SplitText(
										$this.find('.module__title'), 
										{
											type: "lines", 
											linesClass: "line++",
										}
									  );	

			const splitTwoUpDesc 	= new SplitText(
										$this.find('.module__desc p'), 
										{
											type: "lines", 
											linesClass: "line++",
										}
									  );

			const splitItemTitle 	= new SplitText(
										$this.find('.item__title div'), 
										{
											type: "lines", 
											linesClass: "line++",
										}
									  );	

			const splitItemDesc 	= new SplitText(
										$this.find('.item__desc p'), 
										{
											type: "lines", 
											linesClass: "line++",
										}
									  );									  						   	
			const twoUpTitleLines 		= $('.module__title [class*="line"]'),
				  twoUpDescLines 		= $('.module__desc [class*="line"]'),
				  itemTitleLines 		= $('.item__title [class*="line"]'),
				  itemDescLines 		= $('.item__desc [class*="line"]'),
				  twoUpWrappablesArr = [
				  	twoUpTitleLines,
				  	twoUpDescLines,
				  	itemTitleLines,
				  	itemDescLines,
				  ];

			$.each( twoUpWrappablesArr, function(i, val) {

				$(this)
					.contents()
			    	.filter(function() {
			    		return this.nodeType === 3
			    	})
			    	.wrap('<div class="line__inner-wrap" />');

			})																	

			/**
			 * ====================================================================================
			 * ====================================================================================
			 * ====================================================================================
			 * EOF Split the stuff
			 */	

			$this.imagesLoaded( function() {	

				// First case scenario - the page is loaded with the top in the viewport
				// 						 HERE, WE USE THE isInViewport plugin to CHECK IF
				// 						 AN ELEMENT IS IN VIEWPORT, WITHOUT SCROLLING (
				// 						 this is why ScrollTrigger can't be used here!!!)
				if ( $this.is( ':in-viewport' ) ) {

					twoUpInit($this);				

				}

				// Second case - the page is loaded with NOT the top in the viewport. 
				// 				 
				// 				 in this case, we can use ScrollTrigger to show the
				// 				 animation to the user when she scrolls back to top!!
				ScrollTrigger.create({
					trigger: $this,
					start: "top bottom", 	// the top of the TRIGGER element reaches the 
													// top of the VIEWPORT
					directional: true,
					end: "bottom top", 	// the bottom of the TRIGGER element reaches the 
												// top (-300px) of the VIEWPORT
					onEnter: self => {

						if ( 
								self.isActive &&
								!$this.is('.anim--two-up--complete')
							) {

							twoUpInit($this);				
						} 					
					
					},
					onEnterBack: self => {

						if ( 
								self.isActive &&
								!$this.is('.anim--two-up--complete')
							) {

							twoUpInit($this);			
						} 					
					
					}								
				});					

			})

		})

	}

})

/**
 * $(window).on('load', function() {}) DOESN'T WORK IN INCOGNITO!!!
 *
 * EVERYTHING that should be processed upon the onload event MUST be handled here!!!
 */
jQuery(window).ready(function($) {
	


})

window.onload = function() {

	// jQuery hasClass alternative in vanilla JS
	//console.log( document.body.classTwoUp.contains('page-template') );
	//console.log( document.body.classTwoUp.contains('loaded') );	

	if ( !document.body.classTwoUp.contains('loaded') ) {

		//document.body.classTwoUp.remove("no-js");
		//document.body.classTwoUp.add('loaded-better');

	}

};